const converSex = (sex) => {
  let response = sex;
  switch (sex) {
    case "FEMALE":
      response = "ຍິງ";
      break;
    case "MALE":
      response = "ຊາຍ";
      break;
    default:
    // code block
  }
  return response;
};

export default converSex;
